var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshopicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 40.625V9.37496C8.3335 7.99362 8.88223 6.66886 9.85898 5.69211C10.8357 4.71536 12.1605 4.16663 13.5418 4.16663H39.5835C40.136 4.16663 40.6659 4.38612 41.0566 4.77682C41.4473 5.16752 41.6668 5.69743 41.6668 6.24996V43.75C41.6668 44.3025 41.4473 44.8324 41.0566 45.2231C40.6659 45.6138 40.136 45.8333 39.5835 45.8333H13.5418C12.1605 45.8333 10.8357 45.2846 9.85898 44.3078C8.88223 43.3311 8.3335 42.0063 8.3335 40.625ZM8.3335 40.625C8.3335 39.2436 8.88223 37.9189 9.85898 36.9421C10.8357 35.9654 12.1605 35.4166 13.5418 35.4166H41.6668",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopicon);
export default __webpack_public_path__ + "static/media/workshop icon.0274b80b36a7735bcd8426bdec5c86de.svg";
export { ForwardRef as ReactComponent };